import { render, staticRenderFns } from "./ui-img.vue?vue&type=template&id=24ffcae5&scoped=true"
import script from "./ui-img.vue?vue&type=script&lang=js"
export * from "./ui-img.vue?vue&type=script&lang=js"
import style0 from "./ui-img.vue?vue&type=style&index=0&id=24ffcae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ffcae5",
  null
  
)

export default component.exports